const textEncoder = new TextEncoder()
const characterCategory = "Extended_Pictographic"
const emojiRegEx = new RegExp(`\\p{${characterCategory}}`, "u")

// btoa / atob alone cannot handle multibyte characters correctly (Umlaute, emoji, etc.)
export function base64Encode(fieldValue: string): string {
    const utf8Bytes = textEncoder.encode(fieldValue)
    const base64String = btoa(String.fromCharCode(...utf8Bytes))

    return base64String.replace(/=+$/, "")
}

export function base64Decode(fieldValue: string): string {
    return new TextDecoder().decode(base64ToBytes(fieldValue))
}

function base64ToBytes(base64: string) {
    const binString = atob(base64)
    const arr = new Uint8Array(binString.length)
    for (let i = 0; i < binString.length; i++) {
        arr[i] = binString.charCodeAt(i)
    }
    return arr
}

export function slugifyUnicodeText(input: string): string {
    return Array.from(input.normalize("NFKD"))
        .map((character: string): string => {
            if (emojiRegEx.test(character)) {
                return character.codePointAt(0)?.toString(16) || ""
            }

            if (/[a-z0-9]/i.test(character)) {
                return character.toLowerCase()
            }

            if (/\s/u.test(character)) {
                return "-"
            }

            return ""
        })
        .join("")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")
}
